module.exports = __webpack_public_path__ + "img/ico-grid-view-active.8063bf30.svg";